import { Icon } from "@chakra-ui/react";
import { BiLogOut } from "react-icons/bi";

function Logout() {
  return <Icon as={BiLogOut} boxSize={5} color="gray" />;
}

export default Logout;
